var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "materialvisial" } },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "上传文件",
            visible: _vm.materialDialogVisible.upload,
            width: "880px",
            "show-close": false,
            "close-on-click-modal": false,
            "append-to-body": _vm.appendToBody
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.materialDialogVisible, "upload", $event)
            }
          }
        },
        [
          _c("div", { staticClass: "material-site" }, [
            _c("div", { staticClass: "uploadList" }, [
              _vm.showUploadFileList.length
                ? _c(
                    "div",
                    _vm._l(_vm.showUploadFileList, function(site, index) {
                      return _c(
                        "el-row",
                        { key: index },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12, title: site.name } },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    color: "#0F0D11",
                                    "font-size": "12px",
                                    "font-weight": "500",
                                    "padding-left": "5px"
                                  }
                                },
                                [_vm._v(_vm._s(site.name))]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("el-col", { attrs: { span: 6 } }, [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "padding-left": "10px",
                                  color: "#767484",
                                  "font-size": "12px"
                                }
                              },
                              [_vm._v(_vm._s(site.size))]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: site.percentage >= 100,
                                  expression: "site.percentage >= 100"
                                }
                              ],
                              attrs: { span: 6 }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-weight": "400",
                                    color: "#767484",
                                    "font-size": "12px"
                                  }
                                },
                                [_vm._v("已完成")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: site.percentage < 100,
                                  expression: "site.percentage < 100"
                                }
                              ],
                              attrs: { span: 6 }
                            },
                            [
                              _c(
                                "span",
                                [
                                  _c("el-progress", {
                                    attrs: {
                                      type: "circle",
                                      percentage: site.percentage,
                                      color: "#409eff",
                                      width: 35
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                : _c(
                    "div",
                    {
                      staticClass: "empty_material",
                      attrs: { slot: "empty" },
                      slot: "empty"
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/image/sources/table_no_data.png"),
                          alt: "加载失败"
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v("暂无数据")])
                    ]
                  )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "m-upload" },
              [
                _c(
                  "el-form",
                  {
                    ref: "materialForm",
                    attrs: {
                      model: _vm.materialForm,
                      rules: _vm.rules,
                      "label-width": "88px"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: " 资源分类:", prop: "categoryId" } },
                      [
                        _c(
                          "el-select",
                          {
                            model: {
                              value: _vm.materialForm.categoryId,
                              callback: function($$v) {
                                _vm.$set(_vm.materialForm, "categoryId", $$v)
                              },
                              expression: "materialForm.categoryId"
                            }
                          },
                          _vm._l(_vm.option1, function(item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: {
                                label: item.categoryName,
                                value: item.id
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.productFlag == 1 && _vm.courseModel == 2
                      ? _c(
                          "el-form-item",
                          { attrs: { label: " 科目:", prop: "subjectId" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { clearable: "" },
                                on: { change: _vm.subjectChange },
                                model: {
                                  value: _vm.materialForm.subjectId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.materialForm, "subjectId", $$v)
                                  },
                                  expression: "materialForm.subjectId"
                                }
                              },
                              _vm._l(_vm.subjectList, function(item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: { label: item.name, value: item.id }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCascader && _vm.courseModel != 1,
                            expression: "isShowCascader && courseModel != 1"
                          }
                        ],
                        attrs: { label: "资源库分类:", prop: "selectedOptions" }
                      },
                      [
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "bottom",
                              width: "300",
                              trigger: "focus"
                            }
                          },
                          [
                            _c("el-tree", {
                              ref: "treeList",
                              staticStyle: {
                                "max-height": "200px",
                                "overflow-y": "auto"
                              },
                              attrs: {
                                data: _vm.cascaderOptions,
                                "check-strictly": "",
                                "show-checkbox": "",
                                "node-key": "id",
                                "default-expanded-keys": [],
                                "default-checked-keys": [],
                                props: _vm.defaultProps,
                                "expand-on-click-node": false
                              },
                              on: { "check-change": _vm.handleCheckChange }
                            }),
                            _vm._v(" "),
                            _c("el-input", {
                              attrs: {
                                slot: "reference",
                                value: _vm.materialForm.selectedOptions,
                                readonly: "",
                                placeholder: "请选择",
                                "suffix-icon": "el-icon-caret-bottom"
                              },
                              slot: "reference"
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "选择文件:", prop: "materialUpload" } },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c(
                              "el-upload",
                              {
                                ref: "addUpload",
                                attrs: {
                                  action: _vm.materialForm.upload.url,
                                  data: _vm.materialForm.upload.data,
                                  headers: _vm.headers,
                                  "show-file-list": false,
                                  "with-credentials": true,
                                  "on-success": _vm.handleAvatarSuccess,
                                  "on-error": _vm.handleAvatarError,
                                  "before-upload": _vm.beforeAvatarUpload,
                                  "on-progress": _vm.uploadProgress,
                                  "on-preview": _vm.handlePreview,
                                  multiple: ""
                                }
                              },
                              [
                                _c("div", { staticClass: "el-upload__text" }, [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/image/sources/add.png"),
                                      alt: ""
                                    }
                                  })
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-p" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "el-upload__tip",
                                  attrs: { slot: "tip" },
                                  slot: "tip"
                                },
                                [
                                  _c("p", { staticClass: "tis-p" }, [
                                    _vm._v("PPT：.ppt .pptx"),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v(" 文档：.doc .docx .pdf")
                                    ]),
                                    _vm._v(" "),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v(" 图片：.png .jpg .jpeg")
                                    ]),
                                    _vm._v(" "),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v(
                                        "视频：.mp4 .asf .mpg .3gp .mov .avi .flv"
                                      )
                                    ]),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("span", [_vm._v("音频：.mp3 ")]),
                                    _vm._v(" "),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v("其他：.xls .xlsx .zip .rar")
                                    ])
                                  ])
                                ]
                              )
                            ])
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.closeHeadlesubmitForm }
                },
                [_vm._v("关 闭")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "删除素材",
            visible: _vm.materialDialogVisible.delete,
            width: "420px",
            "before-close": _vm.handleDeleteDialogClose
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.materialDialogVisible, "delete", $event)
            }
          }
        },
        [
          _c("span", [
            _vm._v("正在删除素材 " + _vm._s(_vm.materialForm.materialName))
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.handleDeleteDialogClose("materialForm")
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.confirmDelete("materialForm")
                    }
                  }
                },
                [_vm._v("确认删除")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0cb1773e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cb1773e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/szrt_revision/new_course_module/editCourse/sourceMaterial/uploadMaterial.vue
// module id = null
// module chunks = 